// extracted by mini-css-extract-plugin
export default {"banner":"mainPage_banner__85DSl","buttonOutline":"mainPage_buttonOutline__zCEKr","bookBlockWrap":"mainPage_bookBlockWrap__V8S77"};